import {MI} from "../init";
import BigWinCounter from "../libs/BigWinCounter";
import {states} from "../../framework/src/engine/madnes/madnes_variables";
import {STATES} from "../../framework/src/states/states";

/**
 * @constructor
 * @returns {AnimsBigWinCounter}
 */
export default function AnimsBigWinCounter() {

    /** @type {?Function} */
    this._resolver;

    /** @type {?Function} */
    this._symbolsPulseResolver;

    /** @type {Array<MadnesObject>} */
    this._symbols;

    this._symbolsLoopStopped = false;

    /** @type {Game} */
    this._game;

    /** @type {GameGroups} */
    this._groups;

    /** @type {GameAssets} */
    this._assets;

    /** @type {Object<string,MadnesAudio>} */
    this._sounds;

    /** @type {AnimsWinCounter} */
    this._winCounter;

    /** @type {CoinsEmitter} */
    this._coinsEmitter;

    this._onBigWinOpen = function() {};

    this._onPulseStart = function() {};

    /** @type {MadnesObject} */
    this._bigwinSparkle;

    /** @type {MadnesObject} */
    this._bigwinLabel;

    /** @type {MadnesObject} */
    this._megawinLabel;

    /** @type {MadnesObject} */
    this._superwinLabel;

    /** @type {MadnesObject} */
    this._bigwinText0;

    /** @type {MadnesObject} */
    this._bigwinText1;

    /** @type {MadnesTween} */
    this._sparklePulseAnim;

    this._bwOpened = false;

    this._prtclsPos = [];

    /** @type {Array<MadnesObject>} */
    this._particles = [];

    /** @type {MadnesObject} */
    this._bubbles;

    /** @type {MadnesTween} */
    this._bubblesAnimTween;

    this._textPosX = 23;
    this._textPosY = 102;

    this._type = "";
}

/** @param {Function} func */
AnimsBigWinCounter.prototype.setOnBigWinOpen = function(func) {
    this._onBigWinOpen = func;
};

/** @param {Function} func */
AnimsBigWinCounter.prototype.setOnPulseStart = function(func) {
    this._onPulseStart = func;
};

/**
 * @param {Game} game
 */
AnimsBigWinCounter.prototype.create = function(game) {

    this._game = game;

    this._groups = game.groups;
    this._assets = game.assets;
    this._sounds = game.sounds;

    this._createBubbles();
    this._createParticles();

    this._winCounter = this._assets.animWinCounter;
    this._coinsEmitter = this._assets.coinsEmitter;

    this._bigwinSparkle = MI.addImg(MI.getWi() / 2, MI.getHe() / 2 - 20, "bigwin_atlas");
    this._bigwinSparkle.setFrameName("sparkle");
    this._bigwinSparkle.setAnchor(0.5, 0.5);
    this._bigwinSparkle.setVisible(false);

    this._bigwinLabel = MI.addImg(0, -20, "bigwin_atlas");
    this._bigwinLabel.setFrameName("bigwin_label");
    this._bigwinLabel.setAnchor(0.5, 0.5);
    this._bigwinLabel.setVisible(false);
    this._bigwinSparkle.addChild(this._bigwinLabel);

    this._megawinLabel = MI.addImg(0, -20, "bigwin_atlas");
    this._megawinLabel.setFrameName("megawin_label");
    this._megawinLabel.setAnchor(0.5, 0.5);
    this._megawinLabel.setVisible(false);
    this._bigwinSparkle.addChild(this._megawinLabel);

    this._superwinLabel = MI.addImg(0, 0, "bigwin_atlas");
    this._superwinLabel.setFrameName("supermegawin_label");
    this._superwinLabel.setAnchor(0.5, 0.5);
    this._superwinLabel.setVisible(false);
    this._bigwinSparkle.addChild(this._superwinLabel);

    this._bigwinText0 = MI.addBitmapText("font_bigwins", this._textPosX, this._textPosY, "", 80);
    this._bigwinText0.setAnchor(0.5, 0.5);
    this._bigwinText0.setAngle(-11);
    this._bigwinText0.setVisible(false);
    this._bigwinSparkle.addChild(this._bigwinText0);

    this._bigwinText1 = MI.addBitmapText("font_bigwins", this._textPosX - 3, this._textPosY - 4, "", 80);
    this._bigwinText1.setAnchor(0.5, 0.5);
    this._bigwinText1.setAngle(-11);
    this._bigwinText1.setVisible(false);
    this._bigwinSparkle.addChild(this._bigwinText1);
};

AnimsBigWinCounter.prototype._createBubbles = function() {

    this._bubbles = MI.addImg(MI.getWi() / 2, MI.getHe() / 2, "");
    this._bubbles.setAnchor(0.5, 0.5);

    var bubbles = MI.addImg(30, -80, "bigwin_atlas").setFrameName("bubbles");
    bubbles.setAnchor(0.5, 0.5);
    bubbles.setAngle(-40);
    this._bubbles.addChild(bubbles);

    bubbles = MI.addImg(-100, -40, "bigwin_atlas").setFrameName("bubbles");;
    bubbles.setAnchor(0.5, 0.5);
    bubbles.setAngle(120);
    this._bubbles.addChild(bubbles);

    bubbles = MI.addImg(40, 40, "bigwin_atlas").setFrameName("bubbles");;
    bubbles.setAnchor(0.5, 0.5);
    bubbles.setAngle(-60);
    this._bubbles.addChild(bubbles);

    bubbles = MI.addImg(100, 20, "bigwin_atlas").setFrameName("bubbles");;
    bubbles.setAnchor(0.5, 0.5);
    bubbles.setAngle(20);
    this._bubbles.addChild(bubbles);

    this._bubbles.setVisible(false);

    this._groups.get("group_pre_cover").add(this._bubbles);
};

AnimsBigWinCounter.prototype._fadeInBubbles = function() {

    this._bubbles.setAlpha(0);
    this._bubbles.setScale(0, 0);
    this._bubbles.setVisible(true);

    MI.addTween().to(this._bubbles, { 'alpha': 1 }, {
        'duration': 350
    });

    MI.addTween().to(this._bubbles, { 'x': 1, 'y': 1 }, {
        'scale': true,
        'duration': 350
    });
};


AnimsBigWinCounter.prototype._createParticles = function() {

    this._prtclsPos = [];
    this._prtclsPos.push({ 'x': MI.getWi() / 2 - 180, 'y': MI.getHe() / 2 - 120 });
    this._prtclsPos.push({ 'x': MI.getWi() / 2 + 200, 'y': MI.getHe() / 2 - 100 });
    this._prtclsPos.push({ 'x': MI.getWi() / 2 - 200, 'y': MI.getHe() / 2 + 120 });
    this._prtclsPos.push({ 'x': MI.getWi() / 2 + 160, 'y': MI.getHe() / 2 + 120 });
    this._prtclsPos.push({ 'x': MI.getWi() / 2 - 20, 'y': MI.getHe() / 2 + 140 });
    this._prtclsPos.push({ 'x': MI.getWi() / 2 + 30, 'y': MI.getHe() / 2 - 120 });
    this._prtclsPos.push({ 'x': MI.getWi() / 2 - 210, 'y': MI.getHe() / 2 + 20 });
    this._prtclsPos.push({ 'x': MI.getWi() / 2 + 240, 'y': MI.getHe() / 2 + 20 });

    var particleFrameNames = MI.generateFrameNames("particles_", 0, 34, "", 5);
    var group = this._groups.get("group_bw_particles");

    for(var i = 0; i < this._prtclsPos.length; i++) {
        var particles = MI.addImg(this._prtclsPos[i]["x"], this._prtclsPos[i]["y"], "particles_atlas");
        particles.setScale(2, 2);
        particles.setAnchor(0.5, 0.5);
        particles.createAnims();
        particles.anims.add("anim", particleFrameNames);
        particles.setVisible(false);
        group.add(particles);

        this._particles[i] = particles;
    }
};

AnimsBigWinCounter.prototype._playParticles = function() {

    var _self = this;

    for(var i = 0; i < this._particles.length; i++) {

        (function(i) {

            MI.createTimer().add(function() {
                _self._particles[i].setVisible(true);
                _self._particles[i].anims.loop("anim");
            }, i * 80);
        } (i));
    }
};

AnimsBigWinCounter.prototype._stopParticles = function() {

    var _self = this;

    for(var i = 0; i < this._particles.length; i++) {

        (function(i) {
            MI.createTimer().add(function() {
                _self._particles[i].setVisible(false);
                _self._particles[i].anims.stop();
            }, i * 80);
        } (i));

    }
};

AnimsBigWinCounter.prototype.reinit = function() {

    this._symbolsLoopStopped = false;

    this._bigwinSparkle.setScale(0, 0);
    this._bigwinSparkle.setAlpha(0);

    for(var i = 0; i < this._particles.length; i++) {
        this._particles[i].setVisible(false);
    }

    this._bwOpened = false;

    this._bigwinText0.setPos(this._textPosX, this._textPosY);
    this._bigwinText1.setPos(this._textPosX - 3, this._textPosY - 4);
};

/**
 * @param {number} win `money`
 * @param {Array<MadnesObject>} symbols
 */
AnimsBigWinCounter.prototype.run = function(win, symbols) {

    this._type = "";

    var _self = this;

    this._symbols = symbols;

    this._assets.fadeInBlackScreen();

    MI.controls.hideAllBtns();

    this._assets.playParticles(symbols, 300, this._groups);

    if(this._game.bonus.inBonus()) {

        _self._sounds["audio_bonus_bg"].fadeOut(500, false, function() {
            _self._sounds["audio_bonus_bg"].pause();
        });
    }

    _self._sounds["remittance_A"].loop();

    if(win < MI.getMegaWinFactor() * MI.getBet()) {
        this._type = "bw";
        this._initBigWin(win);
    } else {

        if(win < MI.getSuperMegaWinFactor() * MI.getBet()) {
            this._type = "mw";
        } else {
            this._type = "smw";
        }

        this._initSuperMegaWin(win);
    }

    this._run();

    return new Promise(function(res) {
        _self._resolver = res;
    });
};

/**
 * @param {number} win
 */
AnimsBigWinCounter.prototype._initBigWin = function(win) {
    var _self = this;

//	return new Promise(function(res) {

    var obj = { 'val': 0 };

    _self._sounds["audio_big_win"].play();

    MI.addTween().to(obj, { 'val': MI.moneyToCoin(win) }, {
        'duration': 8800,
        'update': function() {
            _self._onUpdate(obj['val'] | 0);
        },
        'callback': function() {
            _self._onUpdate(MI.moneyToCoin(win));
            _self._end();
//				res();
        }
    });
//	});
};

AnimsBigWinCounter.prototype._initSuperMegaWin = function(win) {
    var _self = this;

    var bwf = MI.getBigWinFactor();
    var mwf = MI.getMegaWinFactor();
    var swf = MI.getSuperMegaWinFactor();

    _self._sounds["audio_mega_win"].play();

    var bigWinCounter = new BigWinCounter(MI.moneyToCoin(win), MI.getBet(), [bwf, mwf, swf]);
    bigWinCounter.onUpdate(function(val) {
        _self._onUpdate(val | 0);
    });

    bigWinCounter.onMegaWin(function(res) {

        //console.log(_self, _self._sparklePulseAnim);

        _self._sparklePulseAnim.pause();
        _self._bubblesAnimTween.pause();

        _self._setBwType("megawin").then(function() {
            _self._sparklePulseAnim.resume();
            _self._bubblesAnimTween.resume();
            res();
        });
    });

    bigWinCounter.onSuperWin(function(res) {

        _self._sparklePulseAnim.pause();
        _self._bubblesAnimTween.pause();

        _self._setBwType("supermegawin").then(function() {
            _self._sparklePulseAnim.resume();
            _self._bubblesAnimTween.resume();
            res();
        });
    });

    bigWinCounter.run().then(function() {
        _self._end();
    });
};

AnimsBigWinCounter.prototype._run = function() {
    var _self = this;

    this._winCounter.init();
    this._winCounter.scaleIn();

    this._assets.lightCoverPulse();

    MI.createTimer().add(function() {
        _self._pulseSymbols();
        _self._runBigWin();
    }, 1300);
};

AnimsBigWinCounter.prototype._end = function() {
    var _self = this;

    MI.createTimer().add(function() {

        _self._coinsEmitter.bigwinStop();

    }, 400);

    _self._sounds["audio_mega_win"].fadeOut(500, true);
    _self._sounds["remittance_A"].stop();

    if(this._type === "smw" || this._type === "mw") {
        _self._sounds["audio_big_win_end"].play();
    }

    this._sparklePulseAnim.stop();
    this._sparklePulseAnim = null;

    this._bubblesAnimTween.stop();
    this._bubblesAnimTween = null;

    _self._pulseWinAnim().then(function() {

        MI.createTimer().add(function() {
            _self._stopParticles();
        } , 200);

        MI.createTimer().add(function() {

            _self._hideAnim();
            _self._assets.fadeOutBlackScreen();
            _self._assets.lightCoverPulseStop();
            _self._assets.hideWinLines();

            _self._stopPulseSymbols().then(function() {

                if(_self._game.bonus.inBonus()) {

                    _self._sounds["audio_bonus_bg"].continue();
                    _self._sounds["audio_bonus_bg"].fadeIn(500);
                }

                _self._resolver && _self._resolver();
                _self._resolver = null;
            });

        }, 500);
    });
};

AnimsBigWinCounter.prototype._runBigWin = function() {
    var _self = this;

    states.setState(STATES.BONUS_WIN);

    this._onBigWinOpen(); //pulse symbols

    this._coinsEmitter.hideCoins();
    this._coinsEmitter.explodeBigwin("bigwin");
    this._coinsEmitter.bigwinPlay();

//  MI.createTimer().add(function() {
    _self._coinsEmitter.showCoins();
//  }, 100);

    MI.createTimer().add(function() {
        _self._sounds["audio_big_win_explosion"].play();
        MI.shakeScreenXY(0.006, 0.006, 400);

        _self._fadeInBubbles();

    }, 200);

    this._openAnim(250).then(function() {
        _self._playParticles();
        _self._pulseSparkleAnim();
        _self._bubblesAnim();
    });
};

/**
 * @param {number} delay
 * @returns {Promise}
 */
AnimsBigWinCounter.prototype._openAnim = function(delay) {
    var _self = this;

    this._bigwinSparkle.setVisible(true);
    this._bigwinLabel.setVisible(true);
    this._megawinLabel.setVisible(false);
    this._superwinLabel.setVisible(false);

    this._bigwinText0.setVisible(true);
    this._bigwinText0.setAlpha(1);
    this._bigwinText1.setVisible(true);
    this._bigwinText1.setAlpha(1);

    return new Promise(function(res) {

        MI.addTween().to(_self._bigwinSparkle, { 'x': 1, 'y': 1 }, {
            'scale': true,
            'delay': delay,
            'duration': 340,
            'callback': function() {
                _self._bwOpened = true;
                res();
            }
        });

        MI.addTween().to(_self._bigwinSparkle, { 'alpha': 1 }, {
            'duration': 340,
            'delay': delay
        });

    });
};

AnimsBigWinCounter.prototype._hideAnim = function() {

    var _self = this;

    return new Promise(function(res) {

        _self._winCounter.hide();

        MI.addTween().to(_self._bigwinText0, { 'alpha': 0 }, {
            'duration': 400
        });

        MI.addTween().to(_self._bigwinText1, { 'alpha': 0 }, {
            'duration': 400
        });

        MI.addTween().to(_self._bigwinSparkle, { 'alpha': 0 }, {
            'duration': 500
        });

        MI.addTween().to(_self._bubbles, { 'alpha': 0 }, {
            'duration': 500,
            'callback': res
        });
    });
};

AnimsBigWinCounter.prototype._pulseSparkleAnim = function() {

    this._sparklePulseAnim = MI.addTween().to(this._bigwinSparkle, { 'x': 0.9, 'y': 0.9 }, {
        'scale': true,
        'duration': 500,
        'count': -1,
        'yoyo': true
    });
};

AnimsBigWinCounter.prototype._bubblesAnim = function() {

    this._bubbles.setScale(1, 1);

    this._bubblesAnimTween = MI.addTween().to(this._bubbles, { 'x': 0.9, 'y': 0.9 }, {
        'scale': true,
        'duration': 1250,
        'count': -1,
        'yoyo': true
    });
};

/**
 * @returns {Promise}
 */
AnimsBigWinCounter.prototype._pulseWinAnim = function() {

    var _self = this;

    this._onPulseStart();

    return new Promise(function(res) {

        MI.addTween().to(_self._bigwinText0, { 'x': 0.85, 'y': 0.85 }, {
            'scale': true,
            'duration': 300,
            'count': 4,
            'yoyo': true,
            'callback': res
        });

        MI.addTween().to(_self._bigwinText1, { 'x': 0.85, 'y': 0.85 }, {
            'scale': true,
            'duration': 300,
            'count': 4,
            'yoyo': true
        });
    });
};

AnimsBigWinCounter.prototype._pulseSymbols = function() {

    var _self = this;

    for(var i = 0; i < this._symbols.length; i++) {
        (function(i, symbol) {

            symbol["_pulseTween"] = MI.addTween().to(symbol, { 'x': 1.025, 'y': 1.025 }, {
                'scale': true,
                'duration': 400,
                'yoyo': true,
                'count': -1,
                'onLoop': function() {

                    if(_self._symbolsLoopStopped) {

                        symbol["_pulseTween"].stop();
                        symbol["_pulseTween"] = null;
                        delete symbol["_pulseTween"];

                        if(symbol.getScaleX() !== 1) {
                            MI.addTween().to(symbol, { 'x': 1, 'y': 1 }, {
                                'scale': true,
                                'duration': 300,
                                'callback': function() {
                                    if(i === _self._symbols.length - 1) {
                                        _self._symbolsPulseResolver && _self._symbolsPulseResolver();
                                        _self._symbolsPulseResolver = null;
                                    }
                                }
                            });
                        }
                        else
                        {
                            if(i === _self._symbols.length - 1) {
                                _self._symbolsPulseResolver && _self._symbolsPulseResolver();
                                _self._symbolsPulseResolver = null;
                            }
                        }
                    }
                }
            });
        } (i, this._symbols[i]));
    }
};

AnimsBigWinCounter.prototype._stopPulseSymbols = function() {
    var _self = this;

    return new Promise(function(res) {
        _self._symbolsPulseResolver = res;
        _self._symbolsLoopStopped = true;
    });
};


AnimsBigWinCounter.prototype._showType = function(type) {
    switch(type) {
        case "megawin":
            this._bigwinLabel.setVisible(false);
            this._superwinLabel.setVisible(false);
            this._megawinLabel.setVisible(true);
            break;
        case "supermegawin":

            this._bigwinText0.setPosY(this._textPosY + 10);
            this._bigwinText1.setPosY(this._textPosY - 4 + 10);

            this._bigwinLabel.setVisible(false);
            this._megawinLabel.setVisible(false);
            this._superwinLabel.setVisible(true);
            break;
    }
};

AnimsBigWinCounter.prototype._setBwType = function(type) {

    var _self = this;

    return new Promise(function(res) {

        _self._coinsEmitter.explodeBigwin(type);

        MI.addTween().to(_self._bubbles, { 'x': 0.3, 'y': 0.3 }, {
            'scale': true,
            'delay': 300,
            'duration': 250,
        });

        MI.addTween().to(_self._bigwinSparkle, { 'x': 0.5, 'y': 0.5 }, {
            'scale': true,
            'delay': 300,
            'duration': 250,
            'callback': function() {

                MI.createTimer().add(function() {
                    _self._sounds["audio_big_win_explosion"].play();
                    MI.shakeScreenXY(0.006, 0.006, 400);
                }, 100);

                _self._showType(type);

                MI.addTween().to(_self._bigwinSparkle, { 'x': 1, 'y': 1 }, {
                    'scale': true,
                    'duration': 200,
                    'callback': res
                });

                MI.addTween().to(_self._bubbles, { 'x': 1, 'y': 1 }, {
                    'scale': true,
                    'duration': 200,
                });
            }
        });
    });
};

AnimsBigWinCounter.prototype._onUpdate = function(val) {

    if(!this._bwOpened) {
        this._winCounter.setText(val);
    }

    this._bigwinText0.setText(val);
    this._bigwinText1.setText(val);
};